enum LogEventTypeEnum {
    Login = 1,
    ChangePassword,
    MedicalNoteCreate,
    MedicalNoteApprove,
    MedicalNoteSave,
    MedicalNoteAddItem,
    MedicalNoteAddConsultationRequest,
    MedicalNoteRemoveConsultationRequest,
    MedicalNoteAddLabRequest,
    MedicalNoteRemoveLabRequest,
    MedicalNoteSendForApproval,
    MedicalNoteChangeConsultationDetails,
    MedicalNoteDelete,
    MedicalNoteUnapprove,
    MedicalDocumentCreate,
    MedicalDocumentApprove,
    MedicalDocumentUnapprove,
    PatientFileOpen,
    PrescriptionPrint,
    PrescriptionAdd,
    PrescriptionDeletePending,
    ActiveMedicationModification,
    MedicationStatusModification,
    ForgotPassword,
    RecoverPassword,
    FormAddition,
    FormDeletion,
    FormModification,
    ElectronicResultFiling,
    ResumeSession,
    PaymentRequestGeneration,
    PaymentRequestDeletion,
    MedicalNoteItemDeletion,
    PdfGenerated_MedicalNote,
    PdfGenerated_MedicationList,
    PdfGenerated_MedicalSummary,
    PdfGenerated_LabRequest,
    PdfGenerated_ConsultationRequest,
    PdfGenerated_GrowthCurve,
    PdfGenerated_VitalSigns,
    PdfGenerated_BillingReport,
    PdfGenerated_BillingReportCSV,
    PdfGenerated_PrivateBill,
    PdfGenerated_Prescription,
    XComPatientImport = 56,
    XComDocumentImport,
    FormSent,
    FormSentFailed,
    Cnesst_InformationPrintedOrExtracted,
    UserCreation,
    UserModification,
    UserDeactivationActivation,
    UserPasswordChange,
    PdfGenerated_ObstetricalFile,
    PharmacyOrderComplete = 71,
    PharmacyPatientConsentedSharingMedicalSummary = 72,
    PatientMergeRequest = 73,
    PatientCallCommunicationHistory_Delete = 74,
    PatientCallCommunicationHistory_Update = 75,
    PatientCallCommunicationHistory_Create = 76,
    OntarioCommonDataSetExport_RequestCreated = 77,
    OntarioCommonDataSetExport_RequestCompleted = 78,
    OntarioCommonDataSetImport_RequestCreated = 79,
    OntarioCommonDataSetImport_RequestFailed = 80,
    OntarioCommonDataSetImport_RequestCompleted = 81
}

export { LogEventTypeEnum };
